// Class: starling.display.SetupAutomator

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
function HxOverrides() {return require("./../../HxOverrides");}
function starling_utils_Execute() {return require("./../../starling/utils/Execute");}

// Constructor

var SetupAutomator = function(onAssign,onRelease) {
	this._onAssign = [];
	this._onRelease = [];
	this.add(onAssign,onRelease);
}

// Meta

SetupAutomator.__name__ = "starling.display.SetupAutomator";
SetupAutomator.__isInterface__ = false;
SetupAutomator.prototype = {
	add: function(onAssign,onRelease) {
		if(onAssign != null && this._onAssign.indexOf(onAssign) == -1) {
			this._onAssign[this._onAssign.length] = onAssign;
		}
		if(onRelease != null && this._onRelease.indexOf(onRelease) == -1) {
			this._onRelease[this._onRelease.length] = onRelease;
		}
	},
	remove: function(onAssign,onRelease) {
		if(onAssign != null) {
			(HxOverrides().default).remove(this._onAssign,onAssign);
		}
		if(onRelease != null) {
			(HxOverrides().default).remove(this._onRelease,onRelease);
		}
	},
	onAssign: function(image) {
		var count = this._onAssign.length;
		var _g = 0;
		var _g1 = count;
		while(_g < _g1) {
			var i = _g++;
			(starling_utils_Execute().default).execute(this._onAssign[i],[image]);
		}
	},
	onRelease: function(image) {
		var count = this._onRelease.length;
		var _g = 0;
		var _g1 = count;
		while(_g < _g1) {
			var i = _g++;
			(starling_utils_Execute().default).execute(this._onRelease[i],[image]);
		}
	}
};
SetupAutomator.prototype.__class__ = SetupAutomator.prototype.constructor = $hxClasses["starling.display.SetupAutomator"] = SetupAutomator;

// Init



// Statics




// Export

exports.default = SetupAutomator;